import httpClient from './http-client';

const endpoint = 'api/awards';

const awardsService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  search: (query) => httpClient.get(`${endpoint}/find/${query}`),

  create: (award) => httpClient.post(`${endpoint}`, award),

  update: (award) => httpClient.put(`${endpoint}/${award.id}`, award),

  delete: (award) => httpClient.delete(`${endpoint}/${award.id}`),
};

export default awardsService;
